<template>
  <v-app>
    <toolbar></toolbar>
    
    <v-content>
      <router-view/>
    </v-content>

    <footer-page></footer-page>
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar'
import FooterPage from './components/Footer'

export default {
  name: 'App',
  components: {
    Toolbar,
    FooterPage
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue